module.exports = __webpack_public_path__ + "static/media/ocean.53b6e748.png";